// js-press-center-item

class Items {
  constructor(node) {
    this.node = node;
    this.$selects = $(node).find('.js-press-center-select');
    this.$items = $(node).find('.js-press-center-item');

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.renderItems = this.renderItems.bind(this);

    this.$selects.each((idx) => {
      const $select = $(this.$selects[idx]);

      $select.change(this.handleSelectChange($select));
    });

    this.state = {
      type: null,
      category: null,
      location: null,
      date: null,
    };
  }

  handleSelectChange($select) {
    return (event) => {
      const type = $select.data('type');
      const selectedIndex = $select.prop('selectedIndex');

      if (selectedIndex !== 0) {
        window.$select = $select;
        this.state[type] = $select.val();
      } else {
        this.state[type] = null;
      }

      this.renderItems();
    };
  }

  renderItems() {
    const $itemsWrap = $('.js-press-center-wrap');
    const $filteredItems = [];

    this.$items.filter((idx) => {
      const $project = $(this.$items[idx]);
      const projectType = $project.data('type');
      const projectCategory = $project.data('category');
      const projectLocation = $project.data('location');
      const projectDate = $project.data('date');

      if (
        (!this.state.type || this.state.type == projectType) &&
        (!this.state.category || this.state.category == projectCategory) &&
        (!this.state.location || this.state.location == projectLocation) &&
        (!this.state.date || this.state.date == projectDate)
      ) {
        $filteredItems.push($project);
      }
    });

    if ($filteredItems.length) {
      $itemsWrap.html($filteredItems);
    } else {
      $itemsWrap.html(`
<div class="middle center-xs marged-75 marged-top-75">
  Ничего не найдено по вашему запросу
</div>
      `)
    }
  }
}

class Accordion {
  constructor(node) {
    this.node = node;
    this.headerNode = $(this.node).children('.js-press-accordion-header')[0];
    this.contentNode = $(this.node).children('.js-press-accordion-content')[0];

    console.log(
      this.node,
      this.headerNode,
      this.contentNode,
    );

    this.handleClick = this.handleClick.bind(this);

    $(this.node).click(this.handleClick);
    $(this.contentNode).click(this.handleContentClick);
  }

  handleClick() {
    this.node.classList.toggle('visible');

    if (this.contentNode.style.maxHeight){
      this.contentNode.style.maxHeight = null;
    } else {
      this.contentNode.style.maxHeight = this.contentNode.scrollHeight + 'px';
    }
  }

  handleContentClick(event) {
    event.stopPropagation();
  }
}

export default () => {
  const selectNodes = Array.from(document.querySelectorAll('.js-press-center'));
  const accordions = Array.from(document.querySelectorAll('.js-press-accordion'));

  if (!selectNodes.length) {
    return;
  }

  accordions.forEach((node) => {
    new Accordion(node);
  });

  selectNodes.forEach((node) => {
    window.pressCenter = new Items(node);
  });
}



// WEBPACK FOOTER //
// ./assets/scripts/components/press-center.js